var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47631 0 0 4.47856 0 10C0 15.5237 4.47856 20 10 20C15.5237 20 20 15.5215 20 10C20 4.47631 15.5214 0 10 0ZM16.4944 16.4966C14.7585 18.2325 12.4537 19.1874 10 19.1874C7.54628 19.1874 5.23928 18.2325 3.50565 16.4966C1.76976 14.7607 0.814867 12.456 0.814867 10.0023C0.814867 7.54853 1.76976 5.24154 3.50565 3.50791C5.24154 1.77202 7.54628 0.817154 10 0.817154C12.4537 0.817154 14.7607 1.77202 16.4944 3.50791C18.228 5.2438 19.1851 7.54853 19.1851 10.0023C19.1851 12.456 18.2303 14.763 16.4944 16.4966Z",
    fill: "#8F99AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52213 5.9586C7.52213 6.52519 7.08869 6.98568 6.41375 6.98568C5.7388 6.98568 5.33249 6.52519 5.34603 5.9586C5.33249 5.36492 5.7659 4.91797 6.4273 4.91797C7.0887 4.91797 7.50859 5.36492 7.52213 5.9586ZM5.40021 14.4033V7.79607H7.4544V14.4033H5.40021Z",
    fill: "#8F99AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10203 9.90577C9.10203 9.08185 9.07494 8.37982 9.04785 7.79743H10.8311L10.9259 8.70262H10.9666C11.2375 8.28276 11.9124 7.64844 13.0072 7.64844C14.3593 7.64844 15.3729 8.54009 15.3729 10.4859V14.4046H13.3187V10.7432C13.3187 9.89223 13.0207 9.30985 12.2781 9.30985C11.7115 9.30985 11.3729 9.70262 11.2375 10.0796C11.1833 10.2015 11.1562 10.4047 11.1562 10.592V14.4024H9.10203V9.90351V9.90577Z",
    fill: "#8F99AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6c76826b43398f05021a2ced6b59436c.svg";
export { ForwardRef as ReactComponent };